const DB_NAME = 'fiskelykke-offline';
const DB_VERSION = 2;
const STORES = ['pending-catches', 'pending-sniker'];

// Bakoverkompatibelt navn brukt av eksisterende add/getAll/remove-wrappere
const LEGACY_STORE_NAME = 'pending-catches';

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      // Oppretter kun stores som ikke allerede finnes — berører aldri eksisterende data
      STORES.forEach((storeName) => {
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { keyPath: 'id', autoIncrement: true });
        }
      });
    };
  });
}

const offlineQueue = {
  // Generisk: legg til data i en navngitt kø
  async addTo(storeName, data) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(storeName, 'readwrite');
      const store = tx.objectStore(storeName);
      const request = store.add({ ...data, queuedAt: Date.now() });
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  },

  // Generisk: hent alle ventende elementer fra en navngitt kø
  async getAllFrom(storeName) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(storeName, 'readonly');
      const store = tx.objectStore(storeName);
      const request = store.getAll();
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  },

  // Generisk: fjern et element fra en navngitt kø
  async removeFrom(storeName, id) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(storeName, 'readwrite');
      const store = tx.objectStore(storeName);
      const request = store.delete(id);
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  },

  // Legg til fangst i offline-køen (bakoverkompatibel tynn wrapper rundt 'pending-catches')
  async add(catchData) {
    return this.addTo(LEGACY_STORE_NAME, catchData);
  },

  // Hent alle ventende fangster (bakoverkompatibel tynn wrapper rundt 'pending-catches')
  async getAll() {
    return this.getAllFrom(LEGACY_STORE_NAME);
  },

  // Fjern en synkronisert fangst (bakoverkompatibel tynn wrapper rundt 'pending-catches')
  async remove(id) {
    return this.removeFrom(LEGACY_STORE_NAME, id);
  },

  // Tell ventende
  async count() {
    const items = await this.getAll();
    return items.length;
  }
};

export default offlineQueue;
